import { useRef, useEffect } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { Adg4Button } from "@/components/adg4/button/src";
import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";
import { TypographyStyles } from "@/libraries/wpl/foundations/src";
import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { useLocalizedImage } from "../use-localized-image";

const ArrowLeft = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="57"
        height="19"
        viewBox="0 0 57 19"
        fill="none"
    >
        <path
            d="M47.5975 10.9419C46.8433 10.6448 46.1387 10.6263 45.439 10.5798C44.6789 10.5288 43.9461 10.6263 43.2126 10.8445C42.5674 11.0394 41.8906 11.0301 41.2469 10.9002C40.0427 10.6541 38.8418 10.7191 37.6313 10.8398C36.8754 10.9141 36.1057 10.9559 35.3502 10.9187C34.8265 10.8909 34.3128 10.7005 33.771 10.5798C33.5183 11.0951 33.05 11.123 32.5499 10.993C31.5174 10.7237 30.4881 10.7609 29.4399 10.8909C28.8694 10.9605 28.2902 10.8862 27.7818 10.5659C27.717 10.5288 27.6383 10.5148 27.5642 10.4963C27.14 11.0116 26.5836 11.0394 25.9952 10.9698C25.05 10.863 24.1001 10.7748 23.1549 10.668C22.5155 10.5938 21.8762 10.5056 21.2369 10.422C20.6022 10.3338 19.9864 10.1759 19.3271 10.4034C18.5099 10.6866 17.6482 10.5705 16.8001 10.5241C15.8315 10.4684 14.8633 10.3199 13.9036 10.3524C12.2623 10.4034 10.6311 10.2827 8.99497 10.227C8.21167 10.1992 7.42824 10.1992 6.64972 10.1388C5.8573 10.0785 5.06505 9.98096 4.28215 9.8649C3.44828 9.7442 2.6146 9.58171 1.78549 9.43315C1.24818 9.34031 0.906913 8.95034 0.630633 8.54181C0.552356 8.42575 0.697626 8.08221 0.828186 7.91508C1.23853 7.38584 1.80078 7.09337 2.46423 6.97267C3.95353 6.69876 5.45586 6.6152 6.95788 6.60127C8.30693 6.58734 9.65548 6.68019 10.9994 6.77768C12.5518 6.88446 14.1047 6.89839 15.6625 6.86125C16.8772 6.82875 18.0961 6.87982 19.3107 6.87053C20.4465 6.86589 21.5824 6.82411 22.7228 6.81482C23.9838 6.80554 25.2447 6.79161 26.5101 6.81482C28.304 6.84268 30.0931 6.90767 31.8869 6.94017C33.1616 6.96338 34.4364 6.98195 35.7121 6.77304C36.4358 6.65234 37.1958 6.71733 37.9326 6.77304C38.9938 6.85196 40.0465 6.77304 41.1037 6.71733C42.3927 6.6477 43.6817 6.57342 44.9754 6.50842C45.3463 6.48985 45.7171 6.50842 46.088 6.48985C46.19 6.48985 46.2923 6.4295 46.3944 6.40165C46.3438 6.3088 46.3166 6.17881 46.238 6.12774C45.7712 5.82134 45.2904 5.5428 44.8236 5.2364C43.5849 4.41933 42.3463 3.60226 41.1123 2.77591C40.6363 2.45558 40.3326 1.97741 40.0148 1.51317C39.8214 1.22998 39.9385 0.965363 40.0601 0.723957C40.1771 0.491836 40.2388 0.176151 40.5635 0.115799C40.7862 0.0740171 41.009 0.0322353 41.2362 0.0136655C42.3631 -0.0838255 43.4093 0.23186 44.446 0.607896C45.1865 0.877157 45.9175 1.17892 46.6674 1.42961C46.9821 1.53638 47.1853 1.71279 47.3416 1.99134C47.452 2.18632 47.5482 2.43237 47.8415 2.15383C47.9719 2.03312 48.1479 2.05169 48.2956 2.20489C48.5125 2.42773 48.7619 2.62735 48.9787 2.85483C49.1263 3.01267 49.2792 3.04053 49.4924 3.03589C50.2946 3.00339 50.9606 3.333 51.4771 3.93188C51.8091 4.3172 52.2252 4.5586 52.6834 4.70716C53.2158 4.87893 53.7014 5.12034 54.103 5.48709C54.8417 6.16024 55.5477 6.86589 56.2491 7.57618C56.549 7.88258 56.5415 8.52324 56.271 8.87142C55.7861 9.49815 55.278 10.1017 54.8069 10.7377C54.555 11.0812 54.3678 11.4758 54.139 11.8426C54.0456 11.9911 53.952 12.1861 53.808 12.2511C53.2459 12.5111 52.9145 12.9985 52.5185 13.4349C52.3555 13.616 52.183 13.8156 51.9739 13.927C51.2954 14.2938 50.6078 14.642 49.9064 14.9576C49.702 15.0505 49.4334 14.9855 49.1968 15.0134C49.0902 15.0273 48.9324 15.0644 48.8949 15.1387C48.5674 15.8026 48.0141 16.1693 47.3183 16.2807C46.2559 16.4525 45.285 16.8982 44.2775 17.2371C43.1168 17.627 41.9562 18.0124 40.8 18.4209C39.9086 18.7366 38.9945 18.913 38.0578 18.9873C37.659 19.0198 37.3491 18.8526 37.1744 18.5509C36.7973 17.887 36.723 17.9102 37.1433 17.2324C37.2227 17.1024 37.3159 16.9817 37.3768 16.8425C37.6111 16.2947 38.1124 16.1461 38.6002 15.9279C39.4363 15.5565 40.2495 15.1341 41.058 14.707C42.1175 14.1452 43.1586 13.5556 44.2088 12.9846C44.7758 12.6736 45.3565 12.395 45.9097 12.0654C46.4628 11.7358 46.9883 11.3644 47.5881 10.9698L47.5975 10.9419Z"
            fill="currentcolor"
        />
    </svg>
);

const ArrowRight = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="63"
        height="22"
        viewBox="0 0 63 22"
        fill="none"
    >
        <path
            d="M52.8512 9.42084C52.0061 9.75593 51.2171 9.77688 50.4335 9.82924C49.5823 9.88683 48.7618 9.77688 47.9409 9.53079C47.2187 9.31089 46.4608 9.32136 45.7397 9.46796C44.391 9.74546 43.0463 9.67216 41.691 9.53603C40.8446 9.45225 39.9828 9.40513 39.1368 9.44702C38.5503 9.47843 37.9748 9.6931 37.3679 9.82924C37.0858 9.24806 36.5614 9.21664 36.0012 9.36324C34.8446 9.66692 33.692 9.62504 32.5184 9.47843C31.8797 9.3999 31.2311 9.48367 30.6612 9.84494C30.5887 9.88683 30.5005 9.90254 30.4175 9.92348C29.9433 9.3423 29.3203 9.31089 28.6613 9.38942C27.6027 9.50985 26.5389 9.60933 25.4803 9.72975C24.7642 9.81353 24.0482 9.91301 23.3321 10.0073C22.6213 10.1067 21.9314 10.2848 21.1935 10.0282C20.2789 9.70881 19.3138 9.83971 18.364 9.89207C17.2793 9.9549 16.1949 10.1224 15.1203 10.0858C13.2825 10.0282 11.4557 10.1643 9.62351 10.2272C8.74634 10.2586 7.86907 10.2586 6.9972 10.3266C6.10976 10.3947 5.22245 10.5047 4.34559 10.6356C3.41164 10.7717 2.47784 10.9549 1.54918 11.1225C0.947357 11.2272 0.564592 11.667 0.254565 12.1278C0.166725 12.2587 0.328847 12.6461 0.474778 12.8346C0.933433 13.4315 1.56256 13.7614 2.30529 13.8975C3.97254 14.2064 5.6547 14.3007 7.33661 14.3164C8.84723 14.3321 10.3575 14.2274 11.8625 14.1174C13.6011 13.997 15.34 13.9813 17.0843 14.0232C18.4444 14.0598 19.8095 14.0022 21.1695 14.0127C22.4413 14.0179 23.7133 14.065 24.9903 14.0755C26.4022 14.086 27.8142 14.1017 29.2313 14.0755C31.2401 14.0441 33.2435 13.9708 35.2523 13.9341C36.6797 13.908 38.1072 13.887 39.5354 14.1226C40.3456 14.2588 41.1967 14.1855 42.0219 14.1226C43.2103 14.0336 44.389 14.1226 45.5727 14.1855C47.016 14.264 48.4594 14.3478 49.9079 14.4211C50.3232 14.442 50.7384 14.4211 51.1538 14.442C51.268 14.442 51.3824 14.5101 51.4967 14.5415C51.4399 14.6462 51.4092 14.7928 51.3211 14.8504C50.7979 15.196 50.259 15.5101 49.7358 15.8557C48.3475 16.7772 46.9592 17.6987 45.5761 18.6307C45.0426 18.992 44.7016 19.5313 44.3451 20.0549C44.1281 20.3743 44.2588 20.6727 44.3946 20.945C44.5251 21.2068 44.5937 21.5628 44.9573 21.6309C45.2066 21.678 45.4559 21.7251 45.7104 21.7461C46.9721 21.856 48.1441 21.5 49.3056 21.0759C50.1352 20.7722 50.9543 20.4319 51.7944 20.1491C52.147 20.0287 52.3748 19.8297 52.5503 19.5156C52.6742 19.2957 52.7823 19.0182 53.1103 19.3323C53.2561 19.4685 53.4533 19.4475 53.6189 19.2747C53.8621 19.0234 54.1417 18.7983 54.3849 18.5417C54.5504 18.3637 54.7216 18.3323 54.9604 18.3375C55.8586 18.3742 56.6049 18.0024 57.1842 17.327C57.5566 16.8924 58.0229 16.6201 58.5363 16.4526C59.1327 16.2589 59.6769 15.9866 60.1272 15.573C60.9554 14.8138 61.7472 14.0179 62.5337 13.2168C62.87 12.8713 62.8626 12.1487 62.5603 11.756C62.0183 11.0492 61.4503 10.3685 60.9238 9.65122C60.6423 9.26376 60.4333 8.81872 60.1776 8.40508C60.0733 8.23753 59.9688 8.01763 59.8077 7.94433C59.1786 7.65112 58.8084 7.10135 58.3656 6.60918C58.1833 6.40498 57.9905 6.17984 57.7566 6.05418C56.9974 5.64055 56.2279 5.24786 55.443 4.89182C55.2143 4.7871 54.9134 4.86041 54.6486 4.82899C54.5291 4.81328 54.3525 4.7714 54.3107 4.68762C53.945 3.9389 53.326 3.52526 52.547 3.3996C51.3577 3.20588 50.2712 2.70323 49.1436 2.32101C47.8445 1.8812 46.5454 1.44663 45.2514 0.985871C44.2537 0.629832 43.2304 0.430869 42.1816 0.347095C41.7351 0.310444 41.3879 0.498936 41.1917 0.839267C40.7683 1.588 40.6852 1.56182 41.1547 2.32625C41.2434 2.47286 41.3477 2.60899 41.4157 2.76606C41.6771 3.38389 42.2383 3.55144 42.7841 3.79753C43.7197 4.2164 44.6296 4.69286 45.5344 5.17456C46.7199 5.8081 47.8847 6.47305 49.0598 7.11706C49.6942 7.46786 50.3441 7.78202 50.9629 8.15376C51.5818 8.52551 52.1697 8.94438 52.8407 9.38942L52.8512 9.42084Z"
            fill="currentcolor"
        />
    </svg>
);

const AiIcon = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 44 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M42.5503 18.9399H33.6003V23.9399H42.5503V18.9399Z"
            fill="url(#paint0_linear_8535_22452)"
        />
        <path
            d="M24.4253 0.814941H19.4253V9.76494H24.4253V0.814941Z"
            fill="url(#paint1_linear_8535_22452)"
        />
        <path
            d="M10.2503 18.9399H1.30029V23.9399H10.2503V18.9399Z"
            fill="url(#paint2_linear_8535_22452)"
        />
        <path
            d="M24.4253 33.115H19.4253V42.065H24.4253V33.115Z"
            fill="url(#paint3_linear_8535_22452)"
        />
        <path
            d="M29.8798 25.8055L26.2913 29.394L39.5053 42.6081L43.0939 39.0195L29.8798 25.8055Z"
            fill="#2684FF"
        />
        <path
            d="M39.5054 0.268255L26.2937 13.4846L29.8829 17.0726L43.0946 3.8562L39.5054 0.268255Z"
            fill="#2684FF"
        />
        <path
            d="M4.3393 0.268122L0.750732 3.85669L13.9648 17.0707L17.5534 13.4822L4.3393 0.268122Z"
            fill="#2684FF"
        />
        <path
            d="M13.9618 25.7963L0.75 39.0127L4.33919 42.6006L17.5509 29.3843L13.9618 25.7963Z"
            fill="#2684FF"
        />
        <defs>
            <linearGradient
                id="paint0_linear_8535_22452"
                x1="33.6003"
                y1="21.4399"
                x2="42.5503"
                y2="21.4399"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0052CC" />
                <stop offset="0.8" stopColor="#2684FF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_8535_22452"
                x1="21.9253"
                y1="9.76494"
                x2="21.9253"
                y2="0.814941"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0052CC" />
                <stop offset="0.8" stopColor="#2684FF" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_8535_22452"
                x1="10.2503"
                y1="-8.56007"
                x2="1.30029"
                y2="-8.56007"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0052CC" />
                <stop offset="0.8" stopColor="#2684FF" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_8535_22452"
                x1="21.9253"
                y1="33.115"
                x2="21.9253"
                y2="42.065"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0052CC" />
                <stop offset="0.8" stopColor="#2684FF" />
            </linearGradient>
        </defs>
    </svg>
);

const sectionStyles = css({
    background: `linear-gradient(to bottom, ${wacToken(
        "color.neutral.light100"
    )} 200px, #fff 200px)`,
    [media.above.md]: {
        padding: "48px 0 32px 0"
    }
});

const containerStyles = css({
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "maxWidth": "min(1301px, 100%)",
    "margin": "0 auto",
    "padding": "64px 0 0 0",
    "zIndex": 0,
    "backgroundColor": wacToken("color.extended.blue200"),

    [media.above.md]: {
        backgroundColor: "unset"
    },

    "&::before": {
        content: "",
        position: "absolute",
        display: "none",
        pointerEvents: "none",
        inset: "0",
        clipPath:
            "polygon(0.500px 0.518px, 1281.500px 0.518px, 1301.500px 100%, 10.500px 100%, 0.500px 0.518px)",
        backgroundColor: wacToken("color.extended.blue200"),
        zIndex: -1,

        [media.above.md]: {
            display: "block"
        }
    }
});

const arrowsStyles = css({
    position: "absolute",
    zIndex: -1,
    pointerEvents: "none",
    width: "100vw",
    maxWidth: "1440px",
    height: "408px",
    inset: "auto auto -8px 50%",
    transform: "translateX(-50%)",
    display: "none",

    [media.above.md]: {
        display: "block"
    }
});

const arrowsLeftStyles = css({
    "position": "absolute",
    "width": "246px",
    "height": "408px",
    "inset": "auto auto 0 0",
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg": {
        position: "absolute"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(1)": {
        color: wacToken("color.primary.black"),
        inset: "106px auto auto 8px",
        transform: "rotate(21deg)"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(2)": {
        color: wacToken("color.extended.blue700"),
        inset: "90px auto auto 87px",
        transform: "rotate(45deg)"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(3)": {
        color: wacToken("color.extended.blue700"),
        inset: "189px auto auto 90px",
        transform: "rotate(24deg)"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(4)": {
        color: wacToken("color.extended.purple500"),
        inset: "155px auto auto 186px",
        transform: "rotate(48deg)"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(5)": {
        color: wacToken("color.primary.black"),
        inset: "254px auto auto 179px",
        transform: "rotate(20deg)"
    }
});

const arrowsRightStyles = css({
    "position": "absolute",
    "width": "267px",
    "height": "408px",
    "inset": "auto 0 0 auto",
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg": {
        position: "absolute"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(1)": {
        color: wacToken("color.primary.black"),
        inset: "244px auto auto 25px",
        transform: "rotate(144deg)"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(2)": {
        color: wacToken("color.extended.blue700"),
        inset: "93px auto auto 88px",
        transform: "rotate(133deg)"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(3)": {
        color: wacToken("color.extended.blue700"),
        inset: "166px auto auto 121px",
        transform: "rotate(144deg)"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> svg:nth-of-type(4)": {
        color: wacToken("color.extended.lime500"),
        inset: "46px auto auto 191px",
        transform: "rotate(121deg)"
    }
});

const contentContainerStyles = css({
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "gap": "8px",
    "textAlign": "center",
    "maxWidth": "min(785px, calc(100% - 64px))",
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".h2": {
        margin: "0"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".body": {
        margin: "0"
    },

    [media.above.sm]: {
        maxWidth: "min(785px, calc(100% - 128px))"
    }
});

const imageContainerStyles = css({
    maxWidth: "min(785px, calc(100% - 64px))",
    margin: "32px 0 0 0",
    lineHeight: "0",

    [media.above.sm]: {
        maxWidth: "min(785px, calc(100% - 128px))"
    }
});

const imageStyles = css({
    width: "100%"
});

export const AISectionImage = () => {
    const showGwp7999JiraFeaturesUpdates = checkFeatureFlagGate(
        featureFlags.gwp7999JiraFeatures
    );
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video || !showGwp7999JiraFeaturesUpdates) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        video.play().catch(() => {
                            // Ignore error likely due to autoplay restrictions or browser power saving
                        });
                    }
                });
            },
            {
                threshold: 0.5
            }
        );

        observer.observe(video);

        return () => {
            observer.disconnect();
        };
    }, [showGwp7999JiraFeaturesUpdates]);

    const localizedImage = useLocalizedImage("artificialIntelligenceImage");
    return (
        <div css={imageContainerStyles}>
            {showGwp7999JiraFeaturesUpdates ? (
                <video
                    ref={videoRef}
                    css={imageStyles}
                    playsInline
                    controls
                    muted
                >
                    <source
                        src="https://dam-cdn.atl.orangelogic.com/AssetLink/ho7s02tnb11qo23023b240eh4467cm5i.mp4"
                        type="video/mp4"
                    />
                    <track kind="captions" srcLang="en" label="English" />
                </video>
            ) : (
                /* eslint-disable-next-line no-restricted-syntax */
                <img
                    css={imageStyles}
                    alt=""
                    src={localizedImage}
                    loading="lazy"
                />
            )}
        </div>
    );
};

const ctaContainerStyles = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "32px 0",
    backgroundColor: wacToken("color.extended.blue200"),

    [media.above.md]: {
        backgroundColor: "unset"
    }
});

export const AISection = () => {
    const intl = useIntl();
    const showGwp7999JiraFeaturesUpdates = checkFeatureFlagGate(
        featureFlags.gwp7999JiraFeatures
    );

    return (
        <section css={sectionStyles}>
            <TypographyStyles>
                <div css={containerStyles}>
                    <div css={arrowsStyles}>
                        <div css={arrowsLeftStyles}>
                            <ArrowLeft />
                            <ArrowLeft />
                            <ArrowLeft />
                            <ArrowLeft />
                            <ArrowLeft />
                        </div>
                        <div css={arrowsRightStyles}>
                            <ArrowRight />
                            <ArrowRight />
                            <ArrowRight />
                            <ArrowRight />
                        </div>
                    </div>
                    <div css={contentContainerStyles}>
                        <AiIcon size="42" />
                        <h2 className="h2">
                            {showGwp7999JiraFeaturesUpdates
                                ? intl.formatMessage({
                                      id: "JiraSoftwareFeaturesPageV2.AISection.Gwp7999Header",
                                      defaultMessage:
                                          "Let Rovo AI handle the busywork of project management"
                                  })
                                : intl.formatMessage({
                                      id: "JiraSoftwareFeaturesPageV2.AISection.Header",
                                      defaultMessage:
                                          "Get work across the finish line faster with Atlassian Intelligence"
                                  })}
                        </h2>
                        <p className="body">
                            {showGwp7999JiraFeaturesUpdates
                                ? intl.formatMessage({
                                      id: "JiraSoftwareFeaturesPageV2.AISection.Gwp7999Description",
                                      defaultMessage:
                                          "Get organized faster, make decisions with complete context, and keep every team in sync so you can focus on the work that matters."
                                  })
                                : intl.formatMessage({
                                      id: "JiraSoftwareFeaturesPageV2.AISection.Description",
                                      defaultMessage:
                                          "Use AI to accelerate productivity, improve collaboration, and make the most of your data to drive forward the work that matters most."
                                  })}
                        </p>
                    </div>
                    <AISectionImage />
                </div>
                <div css={ctaContainerStyles}>
                    <Adg4Button
                        variant="secondary"
                        color="black"
                        href={useLocalizedHref("/software/jira/ai")}
                        dataEventProps={{
                            "data-product-key": "jiraSoftware",
                            "data-event": "clicked",
                            "data-event-container": "jiraFeaturesAiSection",
                            "data-event-component": "linkButton"
                        }}
                    >
                        {showGwp7999JiraFeaturesUpdates
                            ? intl.formatMessage({
                                  id: "JiraSoftwareFeaturesPageV2.AISection.Gwp7999Cta",
                                  defaultMessage: "Explore Rovo AI in Jira"
                              })
                            : intl.formatMessage({
                                  id: "JiraSoftwareFeaturesPageV2.AISection.Cta",
                                  defaultMessage:
                                      "Explore Atlassian Intelligence"
                              })}
                    </Adg4Button>
                </div>
            </TypographyStyles>
        </section>
    );
};
